export const START_PAGE_ATTRIBUTE = "preferred_start_page";
export const START_PAGE_DASHBOARD = "dashboard";
export const START_PAGE_MY_ENVIRONMENT = "my";
export const START_PAGE_REPORTS = "reports";
export const START_PAGE_PORTAL = "portal";
const START_PAGES = [
  START_PAGE_DASHBOARD,
  START_PAGE_MY_ENVIRONMENT,
  START_PAGE_REPORTS,
  START_PAGE_PORTAL,
];
const PARENT_PORTAL_ROLES = new Set(["parent", "parent_reader"]);

const firstValue = (value) => (Array.isArray(value) ? value[0] : value);

export const hasParentPortalRole = (roles) =>
  Array.isArray(roles) && roles.some((role) => PARENT_PORTAL_ROLES.has(String(role).toLowerCase()));

export const normalizeStartPagePreference = (value) => {
  const normalized = String(firstValue(value) || "").trim().toLowerCase();
  return START_PAGES.includes(normalized) ? normalized : null;
};

export const pickStartPagePreference = (profile, token) =>
  normalizeStartPagePreference(
    profile?.attributes?.[START_PAGE_ATTRIBUTE] ??
      profile?.[START_PAGE_ATTRIBUTE] ??
      token?.[START_PAGE_ATTRIBUTE]
  );

export const withStartPagePreference = (attributes, preference) => ({
  ...(attributes || {}),
  [START_PAGE_ATTRIBUTE]: [
    normalizeStartPagePreference(preference) || START_PAGE_DASHBOARD,
  ],
});

/** Start pages this user can actually open, in the default order. */
export const availableStartPages = ({
  canViewDashboard,
  canViewMyEnvironment,
  canViewReports,
  canUseParentPortal,
}) => [
  canViewDashboard && START_PAGE_DASHBOARD,
  canViewMyEnvironment && START_PAGE_MY_ENVIRONMENT,
  canViewReports && START_PAGE_REPORTS,
  canUseParentPortal && START_PAGE_PORTAL,
].filter(Boolean);

const STAFF_START_ROUTES = {
  [START_PAGE_DASHBOARD]: "/dashboard",
  [START_PAGE_MY_ENVIRONMENT]: "/my",
  [START_PAGE_REPORTS]: "/reports",
};

/** First staff page to open, or null when the user has no staff start page. */
export const resolveStaffStartRoute = ({
  preference,
  canViewDashboard,
  canViewMyEnvironment,
  canViewReports,
  canViewClassrooms,
  canViewWaitingList,
}) => {
  const staffPages = availableStartPages({ canViewDashboard, canViewMyEnvironment, canViewReports });
  if (staffPages.includes(preference)) return STAFF_START_ROUTES[preference];
  if (staffPages.length > 0) return STAFF_START_ROUTES[staffPages[0]];
  if (canViewClassrooms) return "/school/classrooms";
  if (canViewWaitingList) return "/school/waiting-list";
  return null;
};

export const resolveStartRoute = ({ preference, canUseParentPortal, ...staffAccess }) => {
  if (preference === START_PAGE_PORTAL && canUseParentPortal) return "/portal";
  return resolveStaffStartRoute({ preference, ...staffAccess }) || "/portal";
};
